import React from 'react'

export type HeaderShowContextValues = {
  show: boolean
  headerExists: boolean
  setShow: (value: boolean) => void
}

export const HeaderShowContext = React.createContext<HeaderShowContextValues>({
  setShow: () => {},
  show: true,
  headerExists: true
})
